import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Gift } from "lucide-react";
import { useTranslation } from "react-i18next";

const CountdownTimer = ({ targetDate }) => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = new Date(targetDate) - new Date();

    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="bg-gradient-to-r from-rose-100 to-pink-100 dark:from-rose-900 dark:to-pink-900 rounded-lg p-6 shadow-md">
      <div className="flex items-center gap-2 mb-4">
        <Gift className="h-5 w-5 text-rose-600 dark:text-rose-300" />
        <h3 className="text-lg font-semibold text-rose-900 dark:text-rose-100">
          {/* Time Until Gift Exchange */}
          {t("TimeUntilGiftExchange")}
        </h3>
      </div>
      <div className="grid grid-cols-4 gap-4">
        {Object.entries(timeLeft).map(([unit, value]) => (
          <motion.div
            key={unit}
            className="text-center"
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <div className="bg-white dark:bg-gray-800 rounded-lg p-3 shadow">
              <div className="text-3xl font-bold text-rose-600 dark:text-rose-400">
                {value}
              </div>
              <div className="text-xs text-gray-600 dark:text-gray-400 mt-1 capitalize">
                {unit}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CountdownTimer;
